export default "__VITE_ASSET__Bt67n87y__"